import { FC } from 'react';

import CrossIcon from '../SvgCustom/svg/CrossIcon';
import * as Styles from './toast.styles';

type ToastProps = {
  bgColor?: string;
  color?: string;
  title?: string;
  icon?: string;
  handleClose?: () => void;
  children: React.ReactNode;
};

const Toast: FC<ToastProps> = ({
  bgColor = 'DFEF9F',
  color = '#108043',
  title = '',
  children,
  handleClose,
  icon,
}) => {
  const hasIcon = icon;
  const hasCloseBtn = handleClose;
  const hasTitle = Boolean(title);

  return (
    <Styles.Container
      $bgColor={bgColor}
    >
      <Styles.LeftContent>
        {hasIcon && <img src={icon} alt="icon" />}
        <Styles.TextContainer $color={color}>
          {hasTitle && <span>{title}</span>}
          <p>{children}</p>
        </Styles.TextContainer>
      </Styles.LeftContent>
      {hasCloseBtn && (
        <img
          onClick={handleClose}
          src={CrossIcon({ colorTheme : color })}
          alt="fechar"
        />
      )}
    </Styles.Container>
  );
};

export default Toast;
